import { faExternalLink } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from 'components/common/Typography'
import { CollectiveProposal } from 'graphql/generated'
import { inflect } from 'inflection'
import Link from 'next/link'
import { useMemo } from 'react'

type TProposal = Pick<CollectiveProposal, 'id' | 'publicUrl' | 'title'>

const limitProposalSize = 2

export const ProposalBatches: React.FC<{
  proposal: TProposal & { batchedProposals: TProposal[] }
  limitedView?: boolean
}> = ({
  proposal: { batchedProposals, publicUrl, id },
  limitedView = false
}) => {
  const batchedProposalsMemoized = useMemo(
    () =>
      batchedProposals
        .slice(0, limitedView ? limitProposalSize : undefined)
        .map(batchedProposal => (
          <li key={`batched-proposal-${batchedProposal.id}`}>
            <Link
              className="text-blue font-medium text-sm"
              target="_blank"
              href={batchedProposal.publicUrl}
            >
              {batchedProposal.title}
            </Link>
          </li>
        )),
    [limitedView, batchedProposals]
  )

  const remainingProposals =
    batchedProposals.length - batchedProposalsMemoized.length

  return (
    <ul className="list-disc pl-6">
      {batchedProposalsMemoized}

      {remainingProposals > 0 && (
        <li key={`proposals-${id}-extras`}>
          <Typography href={publicUrl} newTab color="blue">
            and {remainingProposals} other
            {inflect(' commands', remainingProposals)}{' '}
            <FontAwesomeIcon icon={faExternalLink} size="xs" />
          </Typography>
        </li>
      )}
    </ul>
  )
}
